/* Handora QA fixes, v5 (20/10/2026). Loaded (defer) from snippets/nail-size-autoselect.liquid on every page.
   1) Cart drawer: opening it adds a history step, so the phone's Back button closes the cart.
   2) A tap on the dimmed page in the first half second after the cart opens does not close it.
   3) Order note: saved to the cart while the shopper types, so Shop Pay and PayPal keep it too.
   4) The cart stays in step across tabs and when a page comes back from the browser's memory.
   5) After "Refresh cart" works, the "could not confirm" line goes away.
   6) "1 eligible set" in the singular.
   7) Phone filter drawer: groups the shopper opened stay open after each filter change, and the
      jump to the products stops under the promo bar instead of behind it.
   8) Product page: the photo zoom script is fetched quietly once the page is idle.
   9) Cart requests wait up to 25s before giving up (was 8s, which showed "could not confirm" on slow
      connections even though the set was added).
  10) Collection, search, favorites and home: the Help and rewards buttons step aside while the shopper
      scrolls through products, and come back at the top and bottom of the page.
   QA round 3 (20/10): links inside the cart (Remove) are left to the theme; the cart sync no longer
   opens the drawer. */
(function () {
  if (window.__hoQaFixes) return;
  window.__hoQaFixes = true;

  var drawer = document.getElementById('cart-drawer');
  var hist = window.__hoHist || (window.__hoHist = { n: 0, fns: [] });

  /* Redraw the cart from the server without opening the drawer (the theme's redraw opens it). */
  function getCart() {
    var c = window.cart;
    if (!c || typeof c.getCart !== 'function') return null;
    var p = null;
    c.openCartDrawer = function () {};
    try { p = c.getCart(); } catch (e) {}
    var put = function () { delete c.openCartDrawer; };
    if (p && typeof p.then === 'function') p.then(put, put); else put();
    return p;
  }

  /* 9: a slow server is not a failed request */
  function patchCart() {
    var c = window.cart;
    if (!c || c.__hoPatched || typeof c.hoFetch !== 'function') return;
    c.__hoPatched = true;
    c.hoFetch = function (url, options) {
      var controller = new AbortController();
      var timer = setTimeout(function () { controller.abort(); }, 25000);
      return fetch(url, Object.assign({}, options, { signal: controller.signal })).then(function (response) {
        ['json', 'text'].forEach(function (name) {
          var read = response[name].bind(response);
          response[name] = function () { return read().finally(function () { clearTimeout(timer); }); };
        });
        return response;
      }, function (error) { clearTimeout(timer); throw error; });
    };
  }
  patchCart();
  document.addEventListener('DOMContentLoaded', patchCart);
  window.addEventListener('load', patchCart);

  /* 1, 2: Back button and early taps */
  var pushed = false, wasOpen = false, openedAt = 0;
  function isOpen() { return !!(drawer && drawer.classList.contains('is-open')); }
  function closeDrawer() { var x = drawer && drawer.querySelector('.cart-drawer__close'); if (x) x.click(); }
  function onDrawer() {
    var open = isOpen();
    if (open === wasOpen) return;
    wasOpen = open;
    if (open) {
      openedAt = Date.now();
      if (!pushed && !(history.state && history.state.hoCart)) { try { history.pushState({ hoCart: 1 }, ''); pushed = true; } catch (e) {} }
    } else if (pushed) {
      pushed = false;
      if (history.state && history.state.hoCart) { try { if (hist.silence) hist.silence(); history.back(); } catch (e) {} }
    }
  }
  if (drawer && 'MutationObserver' in window) {
    new MutationObserver(onDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('popstate', function (e) {
      if (!pushed || !isOpen() || (e.state && e.state.hoCart)) return;
      pushed = false;
      e.stopImmediatePropagation();
      closeDrawer();
    }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && openedAt && Date.now() - openedAt < 500 && t.closest('.drawer__overlay')) { e.preventDefault(); e.stopImmediatePropagation(); }
    }, true);
    /* A plain link inside the open cart (a product name, a suggestion): leave the cart's history step
       first, then follow it. Runs after the theme's own handlers, so anything the theme handles itself
       (Remove, quantity, checkout) is left alone, and cart links are never touched. */
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!pushed || !isOpen() || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = t.closest('#cart-drawer a[href]');
      if (!a || a.hasAttribute('data-cart-drawer-toggle') || a.hasAttribute('data-item-remove') || (a.target && a.target !== '_self')) return;
      var url;
      try { url = new URL(a.href, location.href); } catch (x) { return; }
      if (url.origin !== location.origin || /^\/(cart|checkout)/.test(url.pathname) || (url.hash && url.pathname === location.pathname)) return;
      e.preventDefault();
      pushed = false;
      var done = false;
      var go = function () { if (done) return; done = true; location.href = url.href; };
      if (hist.silence) { hist.once = go; hist.silence(); }
      try { history.back(); } catch (x) { go(); }
      setTimeout(go, 600);
    });
  }

  /* 3: order note */
  var noteTimer = 0, noteSent = null;
  function isNote(el) { return el && el.tagName === 'TEXTAREA' && el.name === 'note'; }
  function saveNote(el) {
    var v = el.value;
    if (v === noteSent) return;
    noteSent = v;
    fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ note: v })
    }).then(function (r) { if (!r.ok) noteSent = null; }, function () { noteSent = null; });
  }
  document.addEventListener('input', function (e) {
    if (!isNote(e.target)) return;
    var el = e.target;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { saveNote(el); }, 600);
  });
  document.addEventListener('focusout', function (e) { if (isNote(e.target)) { clearTimeout(noteTimer); saveNote(e.target); } });

  /* 4: other tabs and the back/forward cache */
  var nativeFetch = window.fetch, lastSync = Date.now();
  window.fetch = function (input, init) {
    var p = nativeFetch.apply(this, arguments);
    try {
      var u = typeof input === 'string' ? input : (input && input.url) || '';
      var m = String((init && init.method) || (input && input.method) || 'GET').toUpperCase();
      if (m !== 'GET' && /\/cart\/(add|change|update|clear)/.test(u)) {
        p.then(function (r) { if (r && r.ok) { try { localStorage.setItem('ho_cart_ts', String(Date.now())); } catch (x) {} } }, function () {});
      }
    } catch (x) {}
    return p;
  };
  function busyTyping() { var a = document.activeElement; return !!(a && (a.tagName === 'TEXTAREA' || a.tagName === 'INPUT') && a.closest && a.closest('#cart-drawer, form[action="/cart"]')); }
  function sync(force) {
    if (!force && Date.now() - lastSync < 15000) return;
    if (busyTyping() || document.querySelector('.pswp--open, dialog[open]')) return;
    lastSync = Date.now();
    var p = getCart();
    var bar = function () { try { document.dispatchEvent(new CustomEvent('cart:refresh')); } catch (x) {} };
    if (p && typeof p.then === 'function') p.then(bar, bar); else bar();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) sync(true); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') sync(false); });
  window.addEventListener('storage', function (e) { if (e.key === 'ho_cart_ts') sync(true); });
  window.addEventListener('online', function () { sync(true); });

  /* 5: "Refresh cart" */
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-ho-atc-status] button');
    if (!b) return;
    var st = b.closest('[data-ho-atc-status]');
    var on = function () {
      document.removeEventListener('ho:atc:complete', on);
      setTimeout(function () { st.textContent = ''; st.hidden = true; }, 0);
    };
    document.addEventListener('ho:atc:complete', on);
    setTimeout(function () { document.removeEventListener('ho:atc:complete', on); }, 15000);
  }, true);

  /* 6: singular "set" */
  function fixSets() {
    document.querySelectorAll('[data-ho-tier-count]').forEach(function (el) {
      if (el.textContent === '1 eligible sets') el.textContent = '1 eligible set';
    });
  }
  /* Run straight from the observer (no animation frame), so it also works in a background tab. */
  function setsSoon() { fixSets(); }
  document.addEventListener('ho:cart', function () { setTimeout(fixSets, 60); });
  var cartPage = document.querySelector('form[action="/cart"]');
  [drawer, cartPage].forEach(function (root) {
    if (root && 'MutationObserver' in window) new MutationObserver(setsSoon).observe(root, { childList: true, subtree: true, characterData: true });
  });
  setsSoon();

  /* 7: phone filter drawer */
  var filters = document.querySelector('.collection__filters');
  if (filters) {
    var desk = window.matchMedia('(min-width: 768px)');
    var keep = null, lastFilter = 0;
    var gkey = function (g) {
      var s = g.querySelector('.collection__filter__title > span');
      return s ? s.textContent.replace(/\s+/g, ' ').trim().replace(/\d+$/, '').trim() : '';
    };
    var remember = function () {
      lastFilter = Date.now();
      if (desk.matches) return;
      keep = {};
      document.querySelectorAll('.collection__filters .collection__filter').forEach(function (g) {
        var t = g.querySelector('.collection__filter__title');
        if (t && t.classList.contains('is-expanded')) keep[gkey(g)] = 1;
      });
    };
    /* The redrawn filters arrive with every group open, then the theme folds them one by one (the jump).
       Set each new group straight to the state the shopper had, before it is painted. */
    var restore = function () {
      if (!keep || desk.matches) return;
      document.querySelectorAll('.collection__filters .collection__filter').forEach(function (g) {
        var t = g.querySelector('.collection__filter__title');
        if (!t || t.__hoSeen) return;
        t.__hoSeen = true;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (!p) return;
        var want = !!keep[gkey(g)];
        if (t.classList.contains('is-expanded') === want) return;
        t.classList.toggle('is-expanded', want);
        t.setAttribute('aria-expanded', want ? 'true' : 'false');
        p.classList.toggle('is-expanded', want);
        p.style.height = want ? 'auto' : '0px';
      });
    };
    /* ...and the theme's own folding (a scripted click on each open group) leaves the kept ones alone. */
    document.addEventListener('click', function (e) {
      if (e.isTrusted || !keep || desk.matches || Date.now() - lastFilter > 8000) return;
      var t = e.target && e.target.closest && e.target.closest('.collection__filters .collection__filter__title');
      var g = t && t.closest('.collection__filter');
      if (g && keep[gkey(g)] && t.classList.contains('is-expanded')) { e.stopImmediatePropagation(); e.preventDefault(); }
    }, true);
    document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('.collection__filters')) remember(); }, true);
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.collection__filters a, .ho-fclear, .collection__filters__close-bottom, [data-close-filters]')) remember();
    }, true);
    /* After Apply (phone), make sure the "Filter and sort" bar is not left under the promo bar. */
    var promoBottom = function () {
      var off = 0;
      document.querySelectorAll('.shopify-section-group-group-header').forEach(function (s) {
        var cs = getComputedStyle(s);
        if ((cs.position === 'sticky' || cs.position === 'fixed') && s.offsetHeight > 0 && s.offsetHeight < 90) off = Math.max(off, s.getBoundingClientRect().bottom);
      });
      return off;
    };
    var unhide = function () {
      var bar = document.getElementById('CollectionStickyBar');
      if (!bar || desk.matches) return;
      var top = bar.getBoundingClientRect().top, off = promoBottom();
      if (off > 0 && top < off - 1 && top > -bar.offsetHeight) window.scrollBy(0, top - off);
    };
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.collection__filters__close-bottom, [data-close-filters]')) [400, 900, 1600].forEach(function (ms) { setTimeout(unhide, ms); });
    });
    var host = filters.closest('.shopify-section') || document.body;
    if ('MutationObserver' in window) new MutationObserver(restore).observe(host, { childList: true, subtree: true });
    /* The theme scrolls to the products after a change; stop below the sticky promo bar. */
    var scrollBefore = window.scrollTo;
    window.scrollTo = function (a, b) {
      if (!desk.matches && Date.now() - lastFilter < 6000) {
        var off = 0;
        document.querySelectorAll('.shopify-section-group-group-header').forEach(function (s) {
          var cs = getComputedStyle(s);
          if ((cs.position === 'sticky' || cs.position === 'fixed') && s.offsetHeight > 0 && s.offsetHeight < 90) off = Math.max(off, s.getBoundingClientRect().bottom);
        });
        if (off > 0) {
          if (a && typeof a === 'object' && typeof a.top === 'number') return scrollBefore.call(window, Object.assign({}, a, { top: Math.max(0, a.top - off) }));
          if (typeof a === 'number' && typeof b === 'number' && b > 0) return scrollBefore.call(window, a, Math.max(0, b - off));
        }
      }
      return scrollBefore.apply(window, arguments);
    };
  }

  /* 10: floating Help and rewards buttons on product lists */
  var body = document.body;
  if (body && (/(^|\s)template-(collection|search|index|list-collections)(\s|$)/.test(body.className))) {
    var fabQueued = 0;
    var fab = function () {
      fabQueued = 0;
      var y = window.scrollY, h = document.documentElement.scrollHeight - window.innerHeight;
      var hide = y > 240 && y < h - 320;
      if (document.documentElement.classList.contains('ho-fab-hide') !== hide) document.documentElement.classList.toggle('ho-fab-hide', hide);
    };
    window.addEventListener('scroll', function () { if (!fabQueued) fabQueued = setTimeout(fab, 80); }, { passive: true });
    fab();
  }

  /* 8: photo zoom script, fetched while idle */
  if (document.body && document.body.classList.contains('template-product')) {
    window.addEventListener('load', function () {
      setTimeout(function () {
        (window.requestIdleCallback || function (f) { setTimeout(f, 1); })(function () {
          var l = document.createElement('link');
          l.rel = 'modulepreload';
          l.href = 'https://cdn.jsdelivr.net/npm/photoswipe@5.4.4/dist/photoswipe.esm.min.js';
          document.head.appendChild(l);
        }, { timeout: 4000 });
      }, 2500);
    });
  }
})();
